import { api } from '@setplex/tria-api'
import { createEvent, createStore, sample } from 'effector'
import { and, not, reset } from 'patronum'
import { options } from '~/core/flags'

// all stores and events, required for banners, are registered elsewhere,
// mostly in old home model, which is loaded for now as a fallback,
// so we need only to load banners here

export const loadBanners = createEvent()
export const resetBanners = createEvent()

const $loaded = createStore(false)
  .on(api.banners.getBannersFx, () => true)
  .reset(resetBanners)

reset({
  clock: resetBanners,
  target: api.banners.$banners,
})

sample({
  clock: loadBanners,
  filter: and(
    not($loaded),
    not(api.banners.getBannersFx.pending),
    options.get('bannerCarouselsEnabled', true)
  ),
  target: api.banners.getBannersFx,
})
